export function truncate(str: string, length: number): string {
  if (!str) return str;
  return str.length > length ? `${str.slice(0, length)}...` : str;
}

export function preventXSS(str: string): string {
  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export function removeTags(str: string): string {
  return str.replace(/(<([^>]+)>)/gi, '');
}
